import { render, staticRenderFns } from "./giftCategoryList.vue?vue&type=template&id=6eb00198&scoped=true&"
import script from "./giftCategoryList.vue?vue&type=script&lang=js&"
export * from "./giftCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./giftCategoryList.vue?vue&type=style&index=0&id=6eb00198&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb00198",
  null
  
)

export default component.exports